export const APP = {
  root: 'app-root',
};

export const LANDING = {
  container: 'landing-container',
  goPricing: 'landing-go-pricing-btn',
  goLogin: 'landing-login-btn',
  goSignup: 'landing-signup-btn',
};

export const AUTH = {
  loginForm: 'login-form',
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-btn',
  loginGoSignup: 'login-goto-signup-btn',
  loginForgot: 'login-forgot-password-link',

  signupForm: 'signup-form',
  signupEmail: 'signup-email-input',
  signupPassword: 'signup-password-input',
  signupReferral: 'signup-referral-input',
  signupSubmit: 'signup-submit-btn',
  signupGoLogin: 'signup-goto-login-btn',

  forgotForm: 'forgot-form',
  forgotEmail: 'forgot-email-input',
  forgotSubmit: 'forgot-submit-btn',

  resetForm: 'reset-form',
  resetPassword: 'reset-password-input',
  resetConfirm: 'reset-confirm-input',
  resetSubmit: 'reset-submit-btn',

  logoutBtn: 'nav-logout-btn',
};

export const PRICING = {
  container: 'pricing-container',
  monthlyBtn: 'pricing-monthly-btn',
  yearlyBtn: 'pricing-yearly-btn',
};

export const MANAGE = {
  container: 'pro-manage-container',
  subscriptionStatus: 'subscription-status-card',
  subscriptionBadge: 'subscription-badge',
  subscriptionPlan: 'subscription-plan-value',
  subscriptionRenewal: 'subscription-renewal-value',
  manageBillingBtn: 'manage-billing-btn',
  upgradeBtn: 'manage-upgrade-btn',

  referralCard: 'referral-link-card',
  referralCode: 'referral-code-value',
  referralLink: 'referral-link-value',
  copyReferralBtn: 'copy-referral-btn',

  operatorsCard: 'operators-referred-card',
  operatorsCount: 'operators-referred-count',
  creditsPending: 'credits-pending-count',
  creditsAwarded: 'credits-awarded-count',
  referralRow: 'referral-row',
  emptyReferrals: 'referral-list-empty',

  milestoneCard: 'milestone-card',
  milestoneTier: 'milestone-current-tier',
  milestoneNext: 'milestone-next-target',
  milestoneProgress: 'milestone-progress-bar',
};

export const INSPECT = {
  container: 'inspect-container',
  input: 'inspect-target-input',
  submit: 'inspect-submit-btn',
  report: 'inspect-report',
  verdict: 'inspect-verdict',
  score: 'inspect-score',
  historyItem: 'inspect-history-item',
  historyList: 'inspect-history-list',
  upgradeGate: 'inspect-upgrade-gate',
};

export const CHECKOUT = {
  successContainer: 'checkout-success-container',
  statusText: 'checkout-status-text',
  goManageBtn: 'checkout-go-manage-btn',
};

export const WATCHLIST = {
  container: 'watchlist-container',
  addForm: 'watchlist-add-form',
  addKind: 'watchlist-add-kind',
  addValue: 'watchlist-add-value',
  addLabel: 'watchlist-add-label',
  addSubmit: 'watchlist-add-submit',
  entityRow: 'watchlist-entity-row',
  entityDelete: 'watchlist-entity-delete',
  entityCheck: 'watchlist-entity-check',
  emptyState: 'watchlist-empty-state',
  alertsPanel: 'watchlist-alerts-panel',
  alertItem: 'watchlist-alert-item',
  markSeenBtn: 'watchlist-mark-seen-btn',
  upgradeGate: 'watchlist-upgrade-gate',
};

export const LEADERBOARD = {
  container: 'leaderboard-container',
  row: 'leaderboard-row',
  totalOperators: 'leaderboard-total-operators',
  totalReferrals: 'leaderboard-total-referrals',
  emptyState: 'leaderboard-empty',
};

export const BULLETIN = {
  container: 'bulletin-container',
  row: 'bulletin-row',
  totalOperators: 'bulletin-total-operators',
  totalSignals: 'bulletin-total-signals',
  emptyState: 'bulletin-empty',
  cta: 'bulletin-cta',
};

export const ADMIN = {
  container: 'admin-attribution-container',
  forbidden: 'admin-forbidden',
  totalPageViews: 'admin-total-page-views',
  totalVisitors: 'admin-total-visitors',
  totalSignups: 'admin-total-signups',
  totalPaid: 'admin-total-paid',
  sourceRow: 'admin-source-row',
  emptyState: 'admin-empty',
  rangeBtn: 'admin-range-btn',
};

export const SIGNALS = {
  container: 'signals-container',
  addForm: 'signals-add-form',
  addKeywords: 'signals-add-keywords',
  addLabel: 'signals-add-label',
  addRssToggle: 'signals-add-rss-toggle',
  addRssUrl: 'signals-add-rss-url',
  addSubmit: 'signals-add-submit',
  queryRow: 'signals-query-row',
  queryDelete: 'signals-query-delete',
  queryScan: 'signals-query-scan',
  filterAll: 'signals-filter-all',
  filterHn: 'signals-filter-hn',
  filterReddit: 'signals-filter-reddit',
  filterRss: 'signals-filter-rss',
  filterQuery: 'signals-filter-query',
  signalItem: 'signals-item',
  markSeenBtn: 'signals-mark-seen-btn',
  emptyState: 'signals-empty',
  upgradeGate: 'signals-upgrade-gate',
};

export const REPORT = {
  shareCard: 'report-card-share',
  shareUrl: 'report-card-share-url',
  copyBtn: 'report-card-copy-btn',
  regenBtn: 'report-card-regen-btn',
  deactivateBtn: 'report-card-deactivate-btn',
  shareCount: 'report-card-share-count',

  publicContainer: 'report-public-container',
  publicCallsign: 'report-public-callsign',
  publicTier: 'report-public-tier',
  publicPaidRefs: 'report-public-paid-refs',
  publicWatched: 'report-public-watched',
  publicAlerts: 'report-public-alerts',
  publicDays: 'report-public-days',
  publicCta: 'report-public-cta',
  publicNotFound: 'report-public-notfound',
};
